export default __webpack_public_path__ + "static/media/Kayak orange paddles.2b768245.jpg";